var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath103(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.563,
    height: 9.563,
    viewBox: "0 0 11.3 11.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M4.923,7.139a8.048,8.048,0,0,0,3.5,3.5L9.593,9.471a.528.528,0,0,1,.542-.128,6.06,6.06,0,0,0,1.9.3.533.533,0,0,1,.531.531v1.854a.533.533,0,0,1-.531.531A9.031,9.031,0,0,1,3,3.531.533.533,0,0,1,3.531,3H5.391a.533.533,0,0,1,.531.531,6.036,6.036,0,0,0,.3,1.9.533.533,0,0,1-.133.542Z",
    transform: "translate(-3 -3)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath103);
export default __webpack_public_path__ + "static/media/Path103.813013061fbfc3347d51853689422aab.svg";
export { ForwardRef as ReactComponent };